import { render, staticRenderFns } from "./ChoicePriority.vue?vue&type=template&id=2e2df2f2&scoped=true"
import script from "./ChoicePriority.vue?vue&type=script&lang=js"
export * from "./ChoicePriority.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2df2f2",
  null
  
)

export default component.exports